import { useContext, useState } from 'react';
import { ContentContext } from '../../contexts/ContentContext';
import useContent from '../../hooks/useContent';
import useUnsavedChanges from '../../hooks/useUnsavedChanges';
import AdminTopbar from '../AdminTopbar';
import SaveBar from '../components/SaveBar';
import ConfirmModal from '../components/ConfirmModal';

export default function FAQEditor() {
  const { content, updateSection } = useContext(ContentContext);
  const { draft, isDirty, saving, lastSaved, update, save, discard } =
    useContent(content.faq);
  useUnsavedChanges(isDirty);

  const [deleteIdx, setDeleteIdx] = useState(null);

  const handleSave    = () => save(patch => updateSection('faq', patch));
  const handleDiscard = () => discard(content.faq);

  const items = draft.items || [];

  const updateItem = (i, patch) =>
    update({ items: items.map((item, idx) => idx === i ? { ...item, ...patch } : item) });

  const addItem = () =>
    update({ items: [...items, { q: 'New question?', a: '' }] });

  const moveItem = (from, to) => {
    const next = [...items];
    const [item] = next.splice(from, 1);
    next.splice(to, 0, item);
    update({ items: next });
  };

  return (
    <div className="adm-page">
      <AdminTopbar title="FAQ" />
      <SaveBar isDirty={isDirty} saving={saving} lastSaved={lastSaved}
               onSave={handleSave} onDiscard={handleDiscard} />

      {deleteIdx !== null && (
        <ConfirmModal
          message="Delete this FAQ item?"
          onConfirm={() => { update({ items: items.filter((_, i) => i !== deleteIdx) }); setDeleteIdx(null); }}
          onCancel={() => setDeleteIdx(null)}
        />
      )}

      <div className="adm-editor">
        <section className="adm-section">
          <h3 className="adm-section__title">Section Heading</h3>
          <div className="adm-field">
            <label className="adm-label">Heading</label>
            <input className="adm-input" value={draft.heading || ''}
              onChange={e => update({ heading: e.target.value })} />
          </div>
        </section>

        <section className="adm-section">
          <h3 className="adm-section__title">Questions & Answers</h3>
          <div className="adm-card-list">
            {items.map((item, i) => (
              <div key={i} className="adm-card-item" draggable
                onDragStart={e => e.dataTransfer.setData('text/plain', i)}
                onDragOver={e => e.preventDefault()}
                onDrop={e => { e.preventDefault(); moveItem(+e.dataTransfer.getData('text/plain'), i); }}>

                <div className="adm-card-item__header">
                  <span className="adm-list__drag">⠿</span>
                  <span className="adm-label" style={{ flex: 1 }}>FAQ {i + 1}</span>
                  <button className="adm-btn adm-btn--danger adm-btn--sm"
                    onClick={() => setDeleteIdx(i)}>✕</button>
                </div>

                <div className="adm-field">
                  <label className="adm-label">Question</label>
                  <input className="adm-input" value={item.q || ''}
                    onChange={e => updateItem(i, { q: e.target.value })} />
                </div>

                <div className="adm-field">
                  <label className="adm-label">Answer</label>
                  <textarea className="adm-textarea" rows={3} value={item.a || ''}
                    onChange={e => updateItem(i, { a: e.target.value })} />
                </div>
              </div>
            ))}
          </div>
          <button className="adm-btn adm-btn--ghost" onClick={addItem}>+ Add Question</button>
        </section>
      </div>
    </div>
  );
}
